import { render } from "./my-loans.vue?vue&type=template&id=37939054&scoped=true"
import script from "./my-loans.vue?vue&type=script&lang=js"
export * from "./my-loans.vue?vue&type=script&lang=js"

import "./my-loans.vue?vue&type=style&index=0&id=37939054&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37939054"]])

export default __exports__